import request from '@/utils/request'

/**
 * 获取模块列表数据
 */
export const getModuleLists = (data) => {
    return request({
        url: '/module/lists',
        params: data
    })
}

/**
 * 获取模块选项列表数据
 */
export const getModuleOptionLists = (data) => {
    return request({
        url: '/module/option/lists',
        params: data
    })
}

/**
 * 模块-详情
 */
export const getModuleDetail = (id) => {
    return request({
        url: `/module/${id}`
    })
}

/**
 * 模块-修改
 */
export const putModule = (data) => {
    return request({
        url: '/module/manage',
        method: 'PUT',
        data
    })
}

/**
 * 模块-添加
 */
export const addModule = (data) => {
    return request({
        url: '/module/manage',
        method: 'POST',
        data
    })
}

/**
 * 模块-删除
 */
export const delModule = (id) => {
    return request({
        url: `/module/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/module/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/module/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/module/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
